@if (isSubsectionPage || isMySpacePage) {
  <div class="d-flex align-items-center buttons me-2">
    <button
      class="d-flex align-items-center justify-content-center btn btn-treeview py-2 px-1"
      title="Treeview"
      (click)="toggleTreeview()"
      [class.active]="treeExpanded"
      [attr.aria-pressed]="treeExpanded"
      aria-controls="mtm-explorer-tree">
      <span class="icon-wrapper">
        <svg
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="treeview-icon">
          <path d="M3.75 4.75V16.75H11.25" stroke="currentColor" stroke-width="1.5" />
          <rect x="0.75" y="0.75" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.5" />
          <path
            d="M10.75 7.75C10.75 7.19772 11.1977 6.75 11.75 6.75H15.75C16.3023 6.75 16.75 7.19772 16.75 7.75V9.75C16.75 10.3023 16.3023 10.75 15.75 10.75H11.75C11.1977 10.75 10.75 10.3023 10.75 9.75V7.75Z"
            stroke="currentColor"
            stroke-width="1.5" />
          <rect x="10.75" y="14.75" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.5" />
          <path d="M10.75 8.75L3.75 8.75" stroke="currentColor" stroke-width="1.5" />
        </svg>
      </span>
    </button>
  </div>
}
